export const PATH_OF_ROUTES = {
  BASE_APP: '/store',
  BASE: '/',
  DEPOSIT_WEB3_INTERACTION: 'deposit-web3-interaction',
  DEPOSIT_WEB3_INTERACTION_SUCCESS: 'deposit-web3-interaction-success',
  CLAIM_WEB3_INTERACTION: 'claim-web3-interaction',
  CLAIM_WEB3_INTERACTION_SUCCESS: 'claim-web3-interaction-success'
};
